export default __webpack_public_path__ + "static/media/purchases.e614271d.svg";